<template>
  <div class="row_center_center vip_type">
    <p style="margin-right: 3px">VIP會員</p>
    <text class="button-icon text-base" style="color: #fff;" v-for="(item) in vipLevel" :key="item">star</text>
  </div>
</template>
<script>
export default {
  computed: {
    vipLevel() {
      // vip 顯示規則
      // level 1 會員 / level 2 一星會員 / level 3 二星會員
      return this.$store.getters["userData/vipLevel"] - 1;
    },
  },
};
</script>
<style lang="scss" scope>
.vip_type {
  height: 24px;
  padding: 0px 8px;
  background-color: #facb00;
  border-radius: 30px;
  font-size: 12px;
  font-family: PingFang SC;
}
</style>
